<template>
  <div class="orderContent clearfix">
    <div class="jiazaiBox" v-if="info===null">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="info!==null" class="searchBox titleBox mb-4">
      <div class="box">
        <h5>
          订单编号：{{info.no}}
          <span class="badge d-none d-md-inline-block float-right badge-secondary" v-if="info.is_state==='3'">已取消</span>
          <span class="badge d-none d-md-inline-block float-right badge-danger" v-if="info.is_state!=='3' && info.is_payment==='1'">待付款</span>
          <span class="badge d-none d-md-inline-block float-right badge-primary" v-if="info.is_state!=='3' && info.is_payment==='2'">已付款</span>
          <span class="badge d-none d-md-inline-block mr-2 float-right badge-danger" v-if="info.is_state!=='3' && info.is_send==='1'">发货中</span>
          <span class="badge d-none d-md-inline-block mr-2 float-right badge-primary" v-if="info.is_state!=='3' && info.is_send!=='1'">已发货</span>
        </h5>
        <h4 class="d-block d-md-none">
          <span class="badge d-none d-md-inline-block badge-secondary" v-if="info.is_state==='3'">已取消</span>
          <span class="badge d-none d-md-inline-block badge-danger" v-if="info.is_state!=='3' && info.is_payment==='1'">待付款</span>
          <span class="badge d-none d-md-inline-block badge-primary" v-if="info.is_state!=='3' && info.is_payment==='2'">已付款</span>
          <span class="badge d-none d-md-inline-block mr-2 badge-danger" v-if="info.is_state!=='3' && info.is_send==='1'">发货中</span>
          <span class="badge d-none d-md-inline-block mr-2 badge-primary" v-if="info.is_state!=='3' && info.is_send!=='1'">已发货</span>
        </h4>
        <p class="content"><small>— 出库：{{billsInfo.no}}</small></p>
        <hr style="border-color:rgba(0,0,0,0.1);">
        <div class="goodsBox row">
          <div class="col-12 col-md-6">
            <span>
              <i class="description">订单金额：</i>{{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{info.payment_total_price}}
            </span>
          </div>
          <div class="col-12 col-md-6">
            <span><i class="description">创建时间：</i> {{info.addtime_ymd}}</span>
          </div>
          <div class="col-12 col-md-6">
            <span>
              <i class="description">付款时间：</i> {{info.is_payment==='1'?'未付款':info.payment_time_ymd}}</span>
          </div>
          <div class="col-12 col-md-6">
            <span>
              <i class="description">付款账户：</i> {{info.is_payment==='1'?'未付款':info.payment_proceeds_title}}
            </span>
          </div>
          <div class="col-12">
            <span class="m-0"><i class="description">订单说明：</i> {{info.content?info.content:'暂无备注...'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="info!==null" class="threeBox yuanjiao mb-4">
      <h5>订单内容</h5>
      <p class="content"><small>— 包含订单内所有的商品列表</small></p>
      <div class="table-responsive">
        <table class="table table-bordered">
          <tr v-for="(app,index) in goodsArr" :key="index">
            <td>
              <span class="content" v-if="app.is_state==='2'">赠送 / </span>{{app.goods_id_name}} × {{app.num}}
            </td>
            <td class="text-right">
              {{info.currencyType==='1'?'￥':''}}{{info.currencyType==='2'?'$':''}}{{app.price_tax_total}}
            </td>
            <td class="text-right">
              <span class="text-danger" v-if="app.send_num!=='0'">发货中{{app.send_num!=='0'?' × '+app.send_num:''}}</span>
              <span class="text-primary" v-if="app.send_num==='0'">已发货</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="info!==null" class="threeBox yuanjiao mb-4">
      <h5 class="mt-0">发货记录</h5>
      <p class="content"><small>— 所有的发货信息都在这里了</small></p>
      <hr class="mb-4" style="border-color:rgba(0,0,0,0.1);">
      <div v-if="billsGoodsArr.length===0" class="emptyBox content">
        暂无发货信息
      </div>
      <dl class="row" v-for="(app,index) in billsGoodsArr" :key="index">
        <dt class="col-sm-3 content">{{app.sendTime}}</dt>
        <dd class="col-sm-9">
          <p>{{app.name}}</p>
          <p>
            数量：× {{app.num}}<span v-if="app.is_serial==='0' && app.refundNumber!=='0' && app.refundNumber"> ， <span class="text-danger">已退：{{app.refundNumber}}</span></span>
          </p>
          <!--设备 -->
          <p class="content" v-if="app.is_serial==='0'" >
            <span class="link no" @click="copyToClipboard(app.remark)"><i class="iconfont icon-copy"></i></span> {{app.remark?app.remark:'无备注信息...'}}
          </p>
          <!--仓储发货-->
          <p class="text-break content" v-if="app.is_serial==='1' && app.sendModel==='1'" v-for='(apps,indexs) in app.serialList' :key=indexs>
            <span class="copy no" @click="copyToClipboard(apps.serial_number)"><i class="iconfont icon-copy"></i></span> {{apps.serial_number}}<span v-if="apps.is_tui===1" class="text-danger"> 退</span>
          </p>
          <!--外部系统发货-->
          <p class="text-break content" v-if="app.is_serial==='1' && app.sendModel==='2'">
            <span class="link no" @click="copyToClipboard(app.remark)"><i class="iconfont icon-copy"></i></span> {{app.remark?app.remark:'无备注信息...'}}
          </p>
        </dd>
      </dl>
    </div>
    <div v-if="info!==null" class="threeBox yuanjiao mb-4">
      <h5 class="mt-0">收件地址</h5>
      <p class="content"><small>— 设备与软件的收货方式</small></p>
      <hr class="mb-4" style="border-color:rgba(0,0,0,0.1);">
      <div class="table-responsive-sm">
        <dl class="row">
          <dt v-if="info.mailInfo && info.mailInfo.mailName && info.mailInfo.mailPhone && info.mailInfo.mailAddress" class="col-sm-3 content">设备收件</dt>
          <dd v-if="info.mailInfo && info.mailInfo.mailName && info.mailInfo.mailPhone && info.mailInfo.mailAddress" class="col-sm-9">
            <p><span class="content">收&nbsp;&nbsp;件&nbsp;&nbsp;人：</span>{{info.mailInfo?info.mailInfo.mailName:'...'}}</p>
            <p><span class="content">收件电话：</span>{{info.mailInfo?info.mailInfo.mailPhone:'...'}}</p>
            <p><span class="content">收件地址：</span>{{info.mailInfo?info.mailInfo.mailAddress:'...'}}</p>
            <hr>
          </dd>
          <dt class="col-sm-3 content">软件收货</dt>
          <dd class="col-sm-9">
            订单详情在线发放激活码
          </dd>
        </dl>
      </div>
    </div>
    <div v-if="info!==null && info.trade_no" class="text-center">
      <p class="content mb-4"><small>交易号：{{info.trade_no}}</small></p>
    </div>
  </div>
</template>

<script>
import resultcommons from '@/util/resultcommons';
import commons from '@/util/commons';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// import { EventBus } from '@/util/eventBus';
import generalMix from '@/util/mix/general';

export default {
  name: 'orderContent',
  props:['parameter'],
  mixins: [generalMix],
  data () {
    return {
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      info:null,
      goodsArr:[],
      billsGoodsArr:[],
      accountsArr:[],
      id:0,
      billsInfo:{}
    }
  },
  methods:{
    // 显示详情
    copyToClipboard(text) {
      commons.copyToClipboard(text);
      this.$message.showMsgBox({
        type: 'success',
        content: '复制成功'
      });
    }
  },
  components: {
    Multiselect
  },
  created() {
    this.id = this.parameter.token;
    // 标签
    resultcommons.apiOrderinfo(this,{token:this.id}).then(app=>{
      if(app.state === 200){
        this.info = app.data.info;
        this.goodsArr = app.data.goodsArr;
        this.billsGoodsArr = app.data.billsGoodsArr;
        this.accountsArr = app.data.accountsArr;
        this.billsInfo = app.data.billsInfo;
      }else{
        this.$message.showMsgBox({
          type: 'warning',
          content: app.message
        });
      }
    });
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

  .orderContent {
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    background: #F5F5F7;
    color: #000000;
    width: 60vw;
    height: 100%;
    padding-bottom: 0;
    overflow-y: auto;
    table{
      margin: 0;
      tr{
        td,th{
          white-space: nowrap;
        }
      }
    }
    .titleBox {
      color: #000000;
      margin-bottom: 30px;
      p {
        margin: 0;
        //color: rgba(255, 255, 255, 0.5);
      }
      h2{
        font-size: 22px;
      }
    }
    div.jiazaiBox{
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      /*box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);*/
      background: #FFFFFF;
      min-height: 100vh;
      .spinner-border{
        width: 3rem;
        height: 3rem;
      }
    }
    div.searchBox{
      display: flex;
      border-radius: 5px;
      padding: 20px;
      background: #FFFFFF;
      div.box{
        flex: 1;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        div.goodsBox{
          span{
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            background: #F5F5F7;
            line-height: 3em;
            padding: 0 15px;
            border-radius: 5px;
            //border: 1px solid rgba(255,255,255,0.1);
            position: relative;
            margin-bottom: 10px;
            i{
              font-style: normal;
            }
          }
        }
      }
    }
    div.threeBox{
      padding: 20px;
      background: #FFFFFF;
      div.emptyBox{
        line-height: 4em;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #F5F5F7;
        border-radius: 5px;
      }
      table{
        tr{
          td,th{

          }
        }
      }
      dl{
        margin: 0;
        dt{
          padding-left: 0;
        }
        dd{
          margin-bottom: 0;
          p{
            margin-bottom: 0.5rem;
            &:last-child{
              padding-bottom: 10px;
              border-bottom: 1px solid #E5E5E5;
              font-size: 13px;
              i{
                font-size: 0.9rem;
              }
            }
            &:first-child{
            }
            span.copy{
              cursor: pointer;
              &:hover{
                color: #28A745;
              }
              &:active{
                color: #212529;
              }
            }
          }
        }
        &:last-child{
          dd{
            margin: 0;
            p:last-child{
              border: 0;
              margin: 0;
              padding: 0;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1200px) {
    .orderContent{
      width: 70vw;
    }
  }

  @media (max-width: 992px) {
    .orderContent{
      width: 90vw;
    }
  }

  @media (max-width: 776px) {
    .orderContent{
      width: 90vw;
      padding: 10px;
      div.searchBox{
        padding: 20px;
      }
      div.threeBox{
        padding: 20px;
      }
    }
  }

  @media (max-width: 575px) {
    .abilityContent{
      div.threeBox{
        dl{
          dt{
            padding: 0;
            color: #000000;
            font-size: 16px;
            margin-bottom: 10px;
          }
          dd{
            margin: 0;
            padding: 0;
            margin-bottom: 15px;
            p{
              margin-bottom: 5px;
              &:nth-child(1){
                font-weight: bold;
              }
              &:last-child{
                margin: 0;
                padding-bottom: 15px;
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/order/Content.vue